/*=============================================== Nav styles ===============================================*/

import styled from "styled-components/macro"
import {
    Spacers,
    ButtonIcon,
    Shadows,
    Mixins,
    Breakpoints,
} from "tsx-library-julseb"

export const NAV_WIDTH = 200

export const StyledButton = styled(ButtonIcon)`
    position: fixed;
    left: 12px;
    box-shadow: ${Shadows.S};
    top: calc(64px + ${Spacers.L});
    z-index: 899;
    transition: left 0.2s ease, background-color 0.2s ease;

    &.open {
        left: calc(${NAV_WIDTH}px - 12px);
    }

    &.modal-open {
        z-index: 9;
    }
`

export const StyledNav = styled.nav`
    position: fixed;
    top: 0;
    left: 0;
    width: 0;
    height: 100vh;
    background-color: ${({ theme }) => theme.Primary50};
    z-index: 888;
    padding: 0;
    padding-top: calc(64px + ${Spacers.L});
    padding-bottom: ${Spacers.L};
    transition: width 0.2s ease, padding 0.2s ease;
    overflow-y: scroll;
    ${Mixins.Flexbox({
        $flexDirection: "column",
        $alignItems: "stretch",
        $gap: "xs",
    })}
    ${Mixins.HideScrollbar}

    &.modal-open {
        z-index: 8;
    }

    a:not(${StyledButton}),
    button:not(${StyledButton}) {
        text-decoration: none;
        padding: 0;
        border: none;
        background-color: transparent;
        color: ${({ theme }) =>
            theme.ColorsHoverDefault({ $color: "primary" })};
        padding-left: ${Spacers.L};
        padding-right: ${Spacers.L};
        ${Mixins.Flexbox({
            $alignItems: "center",
            $justifyContent: "space-between",
        })}

        &.active {
            background-color: ${({ theme }) => theme.Primary100};
            color: ${({ theme }) =>
                theme.ColorsHoverDefault({ $color: "primary" })};
        }

        @media ${Breakpoints.Hover} {
            &:hover {
                color: ${({ theme }) =>
                    theme.ColorsHoverHover({ $color: "primary" })};
            }

            &:active {
                color: ${({ theme }) =>
                    theme.ColorsHoverActive({ $color: "primary" })};
            }

            &.active {
                &:hover {
                    color: ${({ theme }) =>
                        theme.ColorsHoverHover({ $color: "primary" })};
                }

                &:active {
                    color: ${({ theme }) =>
                        theme.ColorsHoverActive({ $color: "primary" })};
                }
            }
        }
    }

    &.open {
        width: ${NAV_WIDTH}px;
    }

    & > * {
        flex-shrink: 0;
    }
`
